import { createContext } from 'react'
//Get all static pages,countries,states etc
const commonContext = createContext()

export default commonContext
